import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import GroupRowHeader from './groupRowHeader.component';
import Subrow from './subrow.component';
import { GroupRendererPropTypes } from './proptypes';

class GroupRow extends PureComponent {
  static propTypes = {
    ...GroupRendererPropTypes,
    fetchReport: PropTypes.func.isRequired,
    showDeletingDriverModal: PropTypes.func.isRequired,
    tagName: PropTypes.string.isRequired,
    closeNewRow: PropTypes.func,
    ibtAmount: PropTypes.number,
    hideGroupingColumns: PropTypes.bool.isRequired,
    toggleVisibility: PropTypes.func.isRequired,
    path: PropTypes.arrayOf(PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.number,
    ])).isRequired,
    account: PropTypes.string,
    changeEditable: PropTypes.func,
  };

  state = {
    isEditable: false,
  };

  componentDidUpdate = prevProps => {
    if (this.props.isOpen && prevProps.isOpen !== this.props.isOpen) {
      this.props.updateStickyElementsPosition();
    }
  };

  toggle = event => {
    const { toggleVisibility, path } = this.props;
    event.preventDefault();
    toggleVisibility(path);
  };

  changeEditable = isEditable => {
    if (this.props.changeEditable) {
      this.props.changeEditable(isEditable);
    }
    this.setState({ isEditable });
  };

  render() {
    const {
      rowData,
      ibtAmount,
      isOpen,
      toggleVisibility,
      suppressHidingDecimalPlacesForPercentage,
      hideGroupingColumns,
      updateStickyElementsPosition,
      displayGroupingColumnsByPercentages,
      nestingLevel,
      path,
      tagName,
      account,
      ...rest
    } = this.props;

    const { isEditable } = this.state;

    const rootClass = classNames(
      'data-rows-group',
      `nested-${nestingLevel}`,
      { 'is-editable': isEditable }
    );

    return (
      <div className={rootClass}>
        <GroupRowHeader
          tagName={tagName}
          account={account}
          rowData={rowData}
          ibtAmount={ibtAmount}
          isOpen={isOpen}
          toggle={this.toggle}
          hideGroupingColumns={hideGroupingColumns}
          suppressHidingDecimalPlacesForPercentage={suppressHidingDecimalPlacesForPercentage}
          displayGroupingColumnsByPercentages={displayGroupingColumnsByPercentages}
        />

        { isOpen && rowData.subrows.map((subrow, idx) => (
          subrow.subrows.length !== 0
            ? <GroupRow
              nestingLevel={nestingLevel + 1}
              key={subrow.countryTaxTypeDescription || subrow.descr}
              account={account || rowData.descr}
              rowData={subrow}
              ibtAmount={ibtAmount}
              suppressHidingDecimalPlacesForPercentage={suppressHidingDecimalPlacesForPercentage}
              hideGroupingColumns={hideGroupingColumns}
              updateStickyElementsPosition={updateStickyElementsPosition}
              displayGroupingColumnsByPercentages={displayGroupingColumnsByPercentages}
              toggleVisibility={toggleVisibility}
              path={[...path, 'subrows', idx]}
              isOpen={subrow.isOpen}
              tagName={tagName}
              changeEditable={this.changeEditable}
              {...rest}
            />
            : <Subrow
              key={idx}
              rowData={subrow}
              ibtAmount={ibtAmount}
              suppressHidingDecimalPlacesForPercentage={suppressHidingDecimalPlacesForPercentage}
              hideGroupingColumns
              updateStickyElementsPosition={updateStickyElementsPosition}
              tagName={tagName}
              changeEditableOnParent={this.changeEditable}
              {...rest}
            />
        ))}
      </div>
    );
  }
}

export default GroupRow;
